import { type UsersQueryPayload, usersQueryOptions } from "api/queries/user";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: UsersQueryPayload };

export const usersQuery = ({ search }: QueriesInput) => usersQueryOptions(search);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [usersQuery(input)];
